import React from 'react';
import Icon from './Success.svg';

export default props => <Icon {...props} />;
